import CoreService from './CoreService';

class LinksService extends CoreService {
  /* eslint-disable no-useless-constructor */
  constructor(endpoint) {
    super(endpoint);
  }

  fetchContent() {
    return this.api.get('/content');
  }

  hideContent(uid) {
    return this.api.post(`/content/hide`, { uid });
  }

  unhideContent(uid) {
    return this.api.post(`/content/unhide`, { uid });
  }
}
const instance = new LinksService('/v3');

export default instance;
